// JOYWEB-2565: single source of truth for validating a store URL slug.
// A valid slug is a non-empty, trimmed string that is not the literal
// 'undefined'/'null' (which is how a missing value stringifies into a URL or
// a stale persisted session). Anything else (non-strings, whitespace-only,
// padded 'undefined', objects, arrays) collapses to '' so callers can treat
// '' as "no valid slug" and enter their recovery path.
export function sanitizeSlug(value) {
    if (typeof value !== 'string') {
        return '';
    }
    var s = value.trim();
    if (!s || s === 'undefined' || s === 'null') {
        return '';
    }
    return s;
}
